import React, { useState } from 'react';

import PlannerIcons from '../../components/shared/PlannerIcons';

export default function ProjectVault({ project, updateProject }) {
  const [newFile, setNewFile] = useState({ name: '', url: '', type: 'Contract' });
  
  const addFile = (e) => {
    e.preventDefault();
    if(!newFile.name || !newFile.url) return;
    
    // Auto-format URL
    let formattedUrl = newFile.url.trim();
    if (!/^https?:\/\//i.test(formattedUrl)) {
        formattedUrl = 'https://' + formattedUrl;
    }

    updateProject(project.id, { 
      vault: [
        ...(project.vault || []), 
        { 
          id: Date.now().toString(), 
          name: newFile.name, 
          url: formattedUrl, 
          type: newFile.type, 
          addedAt: new Date().toISOString() 
        }
      ] 
    });
    setNewFile({ name: '', url: '', type: 'Contract' });
  };

  const removeFile = (id) => {
    updateProject(project.id, { vault: project.vault.filter(f => f.id !== id) });
  };

  const files = project.vault || [];

  return (
    <div className="space-y-6 animate-fade-in">
       <div className="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-xl p-4 md:p-6 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
        <div>
          <h3 className="text-indigo-900 font-bold text-lg flex items-center gap-2"><span>📂</span> Contract & File Vault</h3>
          <p className="text-indigo-700 text-sm mt-0.5">Store links to external vendor contracts, Google Drive folders, permits, and important event documents.</p>
        </div>
      </div>

       <form onSubmit={addFile} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex flex-col sm:flex-row flex-wrap gap-3 sm:items-end">
          <div className="w-full sm:w-40">
            <label className="text-xs font-semibold text-gray-600 mb-1 block">Document Type</label>
            <select value={newFile.type} onChange={e => setNewFile({...newFile, type: e.target.value})} className="w-full p-2.5 border border-gray-300 rounded-md text-sm font-medium focus:border-indigo-500 outline-none focus:ring-1 focus:ring-indigo-500">
              <option>Contract</option>
              <option>Invoice / Receipt</option>
              <option>Permit / Insurance</option>
              <option>Menu / Catering</option>
              <option>Mood Board / Design</option>
              <option>Folder / Drive</option>
              <option>Other</option>
            </select>
          </div>
          <div className="w-full sm:flex-1 sm:min-w-[200px]">
            <label className="text-xs font-semibold text-gray-600 mb-1 block">Document Name</label>
            <input type="text" value={newFile.name} onChange={e => setNewFile({...newFile, name: e.target.value})} className="w-full p-2.5 border border-gray-300 rounded-md text-sm font-medium focus:border-indigo-500 outline-none focus:ring-1 focus:ring-indigo-500" required placeholder="e.g. Venue Contract PDF" />
          </div>
          <div className="w-full sm:flex-1 sm:min-w-[200px]">
            <label className="text-xs font-semibold text-gray-600 mb-1 block">File Link (URL)</label>
            <input type="text" value={newFile.url} onChange={e => setNewFile({...newFile, url: e.target.value})} className="w-full p-2.5 border border-gray-300 rounded-md text-sm font-medium focus:border-indigo-500 outline-none focus:ring-1 focus:ring-indigo-500" required placeholder="https://drive.google.com/..." />
          </div>
          <button type="submit" className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2.5 rounded-md text-sm font-bold transition shadow-sm">Save Link</button>
        </form>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {files.length > 0 ? files.map((file) => (
              <div key={file.id} className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 hover:border-indigo-300 hover:shadow-md transition group relative">
                  <div className="absolute top-4 right-4">
                      <button onClick={() => removeFile(file.id)} className="text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition p-1 bg-white rounded-full">
                          <PlannerIcons.Trash />
                      </button>
                  </div>
                  <span className="text-[10px] font-bold uppercase tracking-wider text-indigo-700 bg-indigo-50 border border-indigo-100 px-2 py-1 rounded-full mb-3 inline-block">{file.type}</span>
                  <h4 className="font-bold text-gray-900 text-lg truncate pr-6">{file.name}</h4>
                  <p className="text-xs text-gray-500 mt-1 mb-5">Added {new Date(file.addedAt).toLocaleDateString()}</p>
                  
                  <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-sm bg-gray-900 text-white hover:bg-indigo-600 px-4 py-2 rounded-lg font-bold transition flex items-center justify-center gap-2">
                      Open Document
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
                  </a>
              </div>
          )) : (
              <div className="col-span-full py-16 text-center text-gray-400 border-2 border-dashed border-gray-200 rounded-xl bg-gray-50/50">
                  <div className="text-4xl mb-3">📂</div>
                  <p className="font-medium text-gray-500">Your vault is empty.</p>
                  <p className="text-sm mt-1">Link external contracts or Google Drive folders to keep everything centralized.</p>
              </div>
          )}
        </div>
    </div>
  );
}